/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



//import EditPatientDataContent from "components/content/EditPatientDataContent";
import NewProviderDataContent from "components/content/NewProviderDataContent";

import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * New medical provider registration page.
 * Generic provider creation interface for various provider types.
 * 
 * Features:
 * - Provider profile creation
 * - Personal and professional information
 * - Credentials and certifications
 * - Specialty selection
 * - License information
 * - Contact details
 * - User account setup
 * - Role and permission assignment
 * - Form validation
 * - Integration with provider management
 * 
 * @returns {JSX.Element} New provider registration page
 */
const NewProviderPage = () => {
  return (
    <DefaultDashboardLayout>
      <NewProviderDataContent />
    </DefaultDashboardLayout>
  );
};

export default NewProviderPage;

